// src/components/banners/ServicesBanner.jsx

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AVIcon from '../icons/AllVoicedIcons';
import { serviceRoutesById } from '../../navigation/publicServiceRoutes';

export default function ServicesBanner() {
  const { t } = useTranslation();

  return (
    <section className="services-banner unified" aria-label="All-Voiced Services">
      <div className="services-content unified">
        <span className="services-eyebrow">
          {t('services_banner_eyebrow', 'All-Voiced Services')}
        </span>

        <h2 className="services-title">
          {t(
            'services_banner_title',
            'Auditory-perceptual voice services'
          )}
        </h2>

        <p className="services-subtitle wide">
          {t(
            'services_banner_text',
            'Perceptual Skill Development, Institutional Programs, Perceptual Research Infrastructure, and Perceptual Data Annotation for education, research, clinical training, and voice technology.'
          )}
        </p>

        <div className="services-icons">
          <Link
            to={serviceRoutesById['perceptual-skill-development'].path}
            className="service-icon"
          >
            <AVIcon icon="listen" size={52} color="#209385" />
            <p>{t('services_banner_training', serviceRoutesById['perceptual-skill-development'].label)}</p>
          </Link>

          <Link
            to={serviceRoutesById['institutional-programs'].path}
            className="service-icon"
          >
            <AVIcon icon="graduationCap" size={52} color="#209385" />
            <p>{t('services_banner_programs', serviceRoutesById['institutional-programs'].label)}</p>
          </Link>

          <Link
            to={serviceRoutesById['perceptual-research-infrastructure'].path}
            className="service-icon"
          >
            <AVIcon icon="research" size={52} color="#209385" />
            <p>{t('services_banner_experiments', serviceRoutesById['perceptual-research-infrastructure'].label)}</p>
          </Link>

          <Link
            to={serviceRoutesById['perceptual-data-annotation'].path}
            className="service-icon"
          >
            <AVIcon icon="tags" size={52} color="#209385" />
            <p>{t('services_banner_annotation', serviceRoutesById['perceptual-data-annotation'].label)}</p>
          </Link>
        </div>

        <div className="services-cta web-cta-row">
          <Link to="/services" className="web-button web-button--primary">
            {t('services_banner_cta_primary', 'Explore services')}
          </Link>

          <Link to="/app" className="web-button web-button--secondary">
            {t('services_banner_cta_secondary', 'Open the app')}
          </Link>
        </div>
      </div>
    </section>
  );
}
